import React from "react";
import Iconify from "@/src/components/iconify/Iconify";
import IconCode from "@/src/lib/iconCode";
import { CustomButton } from "@/src/lib/ui";

const VisuallyHiddenInput = ({ onChange }) => (
    <input
        type="file"
        onChange={onChange}
        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
    />
);

export default function InputFileUpload({ onFileChange, isDisabled }) {
    return (
        <div className="relative w-full">
            <CustomButton
                fullWidth
                variant="outlined"
                startIcon={
                    <Iconify icon={IconCode.upload} className="text-primary" />
                }
                disabled={isDisabled}
            >
                Upload File
            </CustomButton>

            {/* Invisible input over the button to capture file click */}
            <VisuallyHiddenInput onChange={onFileChange} />
        </div>
    );
}
